export default "__VITE_ASSET__CBO5Vk8b__"